import React, { useState, useEffect } from 'react'
import { Card } from 'pcln-design-system'
import {
  IMediaCard,
  IGoogleAnalyticsTrackingType
} from '@pcln/contentful-components'
import { ModalContent } from '@/types'
import { MediaCard } from '@pcln/marketing'
import gaAnalytics from '@/shared-utils/analytics'
import MoreInfoModal from '../Modal/MoreInfoModal'

export default function MediaCardComponent({
  content
}: {
  content: IMediaCard
}) {
  const {
    heading,
    overline,
    subheading,
    media,
    analyticsTracking,
    primaryCallToAction
  } = content

  const [isOpen, setIsOpen] = useState(false)
  const [currentModalProps, setCurrentModalProps] = useState<ModalContent>()

  const handleOpen = (
    modalProps: ModalContent,
    gaTracking: IGoogleAnalyticsTrackingType
  ) => {
    if (gaTracking?.category && gaTracking?.action && gaTracking?.label) {
      const gaParams = {
        category: gaTracking?.category,
        action: gaTracking?.action,
        label: gaTracking?.label
      }
      gaAnalytics.fireEvent(gaParams)
    }
    if (modalProps) {
      setCurrentModalProps(modalProps)
      setIsOpen(true)
    }
  }

  const handleClose = () => {
    setCurrentModalProps(undefined)
    setIsOpen(false)
  }

  useEffect(() => {
    if (analyticsTracking?.action && analyticsTracking?.label) {
      gaAnalytics.fireEvent({
        category: analyticsTracking?.category,
        action: analyticsTracking?.action,
        label: analyticsTracking?.label
      })
    }
  }, [analyticsTracking])

  return (
    <>
      <MoreInfoModal
        {...currentModalProps}
        isFullHeight={false}
        isOpen={isOpen}
        handleClose={() => {
          handleClose()
        }}
      />
      <Card borderWidth={0} width={[1, null, 1 / 2]}>
        <MediaCard
          boxShadowSize="md"
          handleOpen={handleOpen}
          asset={{
            file: {
              contentType: 'Image',
              details: {
                image: {
                  height: 200,
                  width: 600
                }
              },
              fileName: media?.file?.fileName,
              url: media?.file.url
            },
            title: media?.title
          }}
          callToAction={primaryCallToAction}
          heading={heading}
          overline={overline}
          subheading={subheading}
          objectFit="cover"
          objectPosition="top"
        />
      </Card>
    </>
  )
}
